module.exports = __webpack_public_path__ + "img/icon1.d86aeb43.png";